import React from 'react';
import { WarningIcon } from '../../../../assets/icons/Warning.icon';
import { ChatIcon } from '../../../../assets/icons/Chat.icon';
import styles from './stylesV2.module.css';


export const ModalPlanIncompatible = ({ onClose, onChooseOtherPlan, onContactSupport }) => (
  <div className={styles.incompatibleOverlay}>
    <div className={styles.incompatibleCard}>
      <div className={styles.incompatibleContent}>
        <div className={styles.incompatibleIconBg}>
          <WarningIcon />
        </div>
        <h2 className={styles.incompatibleTitle}>Dados da viagem <br className={styles.incompatibleTitleBr} /> incompatíveis com o plano</h2>
        <p className={styles.incompatibleBody}>
          O <b>destino ou as datas selecionadas</b> não são cobertos pelo plano selecionado pelo seu vendedor. Por favor, escolha um plano compatível ou fale com um atendente para ajustar sua cotação.
        </p>
      </div>
      <div className={styles.incompatibleActions}>
        <button className={styles.incompatiblePrimaryBtn} onClick={onChooseOtherPlan}>
          Escolher outro plano
        </button>
        <button className={styles.incompatibleSecondaryBtn} onClick={onContactSupport || onClose}>
          <ChatIcon />
          Falar com atendente
        </button>
      </div>
    </div>
  </div >
);

export default ModalPlanIncompatible;



// WEBPACK FOOTER //
// ./src/components/purchase/modal_operator_confirmation/v2/ModalPlanIncompatible.jsx